export default __webpack_public_path__ + "static/media/buttonsMiiClip.27ca06ee.mp4";